import 'core-js/client/shim';
import 'reflect-metadata';

(window as any).__Zone_disable_requestAnimationFrame = true;
import 'zone.js/dist/zone';

import 'ts-helpers';

if (process.env.ENV !== 'production') {
    Error['stackTraceLimit'] = Infinity;
    require('zone.js/dist/long-stack-trace-zone');
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/polyfills.ts